import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ReceivableFinancingLimitModalUI from './ReceivableFinancingLimitModalUI.js'

class ReceivableFinancingLimitModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      receivableFinancingLimit: this.props.loan.account.limitF || '',
      receivableFinancingLimitError: null,
    }
  }

  render() {
    return (
      <ReceivableFinancingLimitModalUI
        context={this.props.context}
        loan={this.props.loan}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}
        // form fields
        receivableFinancingLimit={this.state.receivableFinancingLimit}
        onReceivableFinancingLimitChange={(event) => { this.setState({ receivableFinancingLimit: event.target.value }) }}
        receivableFinancingLimitError={this.state.receivableFinancingLimitError}
        setReceivableFinancingLimitError={(error) => { this.setState({ receivableFinancingLimitError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.loan.accountId}/receivableFinancing`,
      this.onSubmitCallback, {
      limit: this.state.receivableFinancingLimit,
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick("noBusy")
      }, 10)
    }
  }

  onCancelClick = () => {
    this.setState({
      errorList: null,
      submitted: false,
    })
    this.props.onCancelClick()
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default ReceivableFinancingLimitModalSF
